import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/config';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.css';
import './styles/overrides.css';
// Sistema canónico de listados: una sola definición por cosa para las tablas,
// barras de filtros, acciones y diálogos de todos los listados. Va después de
// los overrides para poder ganarles, e incluye como alias las clases históricas
// (wol-*, pel-*, *-table) para que las páginas no tengan que cambiar.
import './styles/lists.css';
// Alto de los lienzos que ocupan la pantalla completa (Mapa de planta,
// Tomas ↔ panel): una sola fórmula en vez de repetir calc(100vh - …).
import './styles/canvas-pages.css';
// Capa de skins (forma). Va la última a propósito: así puede ajustar radios,
// sombras y superficies por encima de Bootstrap y de los CSS de componente.
import './styles/skins.css';
// Densidad de las tablas: DESPUÉS de los skins para poder ganarles el relleno
// de celda (es preferencia del usuario, ver theme/density.js).
import './styles/density.css';
// Fondo (degradados difuminados por paleta). Va el último para poder sustituir
// la rejilla que traía `design-system.css` en `body::before`.
import './styles/background.css';
import { bootAppearance } from './theme/appearance';
import { bootBackground } from './theme/background';
import { bootDensity } from './theme/density';
import { registrarServiceWorker } from './pwa';

// El aspecto se aplica antes de pintar nada para que no haya parpadeo de tema.
bootAppearance();
// Y el fondo, por el mismo motivo.
bootBackground();
// Densidad de las tablas (auto/cómoda/compacta), también antes de pintar para
// que las filas no “salten” de alto al cargar.
bootDensity();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA: deja la app instalable en el móvil (solo en compilación de producción).
registrarServiceWorker();
